// extracted by mini-css-extract-plugin
export var body = "_jb-8";
export var button = "_jb-0";
export var closeButton = "_jb-5";
export var content = "_jb-3";
export var empty = "_jb-f";
export var grid = "_jb-c";
export var header = "_jb-4";
export var icon = "_jb-1";
export var option = "_jb-d";
export var optionSelected = "_jb-e";
export var overlay = "_jb-2";
export var searchIcon = "_jb-a";
export var searchInput = "_jb-b";
export var searchWrapper = "_jb-9";
export var title = "_jb-6";
export var visuallyHidden = "_jb-7";